import * as React from 'react'
import MUIInputLabel from '@mui/material/InputLabel'

const InputLabel = (props) => <MUIInputLabel {...props} />

export default InputLabel
